import { DateRange } from 'src/providers/SelectedDateRangesProvider';
import { Departure } from './departures.model';
import { addDays, isAfter, isBefore, subDays } from 'date-fns';

export const filterDepartures = (
  departures: Departure[],
  selectedDateRanges: DateRange[],
): Departure[] => {
  return departures.filter((departure) => {
    if (departure.status === 'SOLD_OUT') return false;

    return selectedDateRanges.some((dateRange) => {
      const { startDate, endDate, bufferDays } = dateRange;
      const { departureDate } = departure;

      const adjustedStartDate = subDays(startDate, bufferDays);
      const adjustedEndDate = addDays(endDate, bufferDays);
      return (
        isAfter(departureDate, adjustedStartDate) &&
        isBefore(departureDate, adjustedEndDate)
      );
    });
  });
};

export const rankDepartures = (departures: Departure[]): Departure[] => {
  const departuresByStatus = groupDeparturesByStatus(departures);
  return [
    ...sortDepartures(departuresByStatus.GUARANTEED, 'asc'),
    ...sortDepartures(departuresByStatus.ON_SALE, 'desc'),
    ...sortDepartures(departuresByStatus.ON_REQUEST, 'date'),
  ];
};

const groupDeparturesByStatus = (departures: Departure[]): Record<string, Departure[]> =>
  departures.reduce(
    (acc, departure) => {
      (acc[departure.status] = acc[departure.status] || []).push(departure);
      return acc;
    },
    {} as Record<string, Departure[]>,
  );

const sortDepartures = (
  departures: Departure[] = [],
  sortType: 'asc' | 'desc' | 'date',
): Departure[] => {
  switch (sortType) {
    case 'asc':
      return departures.sort((a, b) => a.occupancy - b.occupancy);
    case 'desc':
      return departures.sort((a, b) => b.occupancy - a.occupancy);
    case 'date':
      return departures.sort(
        (a, b) => b.departureDate.getTime() - a.departureDate.getTime(),
      );
  }
};
